/* SIGN IN */

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";

/* USER PROFILE */

export const GET_USERPROFILE = "GET_USERPROFILE"
export const EDIT_USERPROFILE = "EDIT_USERPROFILE"